var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useMutation, useQuery, useQueryClient } from 'react-query';
import moment from 'moment-timezone';
import { useChuckClientContext } from './useChuckClientContext';
import { CacheKeys } from '../constants';
import { useAPI } from './useAPI';
export const useAvailabilityQuery = ({ user, timezone }) => {
    const { get } = useAPI();
    return useQuery(CacheKeys.AVAILABILITY, () => {
        return get({
            url: `/availabilities?user=${user}&timezone=${timezone ? timezone : moment.tz.guess()}`
        }).then((res) => res.data);
    });
};
export const useAvailabilityUpdate = ({ user, timezone }) => {
    const { post } = useAPI();
    const queryClient = useQueryClient();
    const { client } = useChuckClientContext();
    return useMutation((data) => {
        return post({
            url: '/availabilities',
            data: {
                timezone: timezone ? timezone : moment.tz.guess(),
                data,
                user
            }
        }).then((res) => res.data);
    }, {
        onMutate: (data) => __awaiter(void 0, void 0, void 0, function* () {
            yield queryClient.cancelQueries(CacheKeys.AVAILABILITY);
            const prev = queryClient.getQueryData(CacheKeys.AVAILABILITY);
            queryClient.setQueryData(CacheKeys.AVAILABILITY, data);
            return { prev };
        }),
        onError: (err, _, context) => {
            if (context)
                queryClient.setQueryData(CacheKeys.AVAILABILITY, context.prev);
            client.captureException(err);
        },
        onSettled: () => {
            queryClient.invalidateQueries(CacheKeys.AVAILABILITY).catch((err) => {
                client.captureException(err);
            });
        }
    });
};
//# sourceMappingURL=useAvailability.js.map